var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "flex-row vat-manager-item",
      class: _vm.isValueRateEmpty ? "" : "pb-2"
    },
    [
      !_vm.value.is_ecotax
        ? _c(
            "div",
            { staticClass: "containerIcon vat-manager-item__anchor" },
            [
              _c("CompassIcon", {
                staticStyle: { cursor: "grab" },
                attrs: {
                  icon: "drag-and-drop",
                  size: "medium",
                  type: "primary"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.value.is_ecotax
        ? _c(
            "div",
            { staticClass: "vat-manager-item__action" },
            [
              _c("el-switch", {
                staticClass: "vat-manager-item__action--switch",
                attrs: {
                  "active-color": _vm.colors.green,
                  "inactive-color": _vm.colors.gray
                },
                model: {
                  value: _vm.value.is_active,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "is_active", $$v)
                  },
                  expression: "value.is_active"
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "vat-manager-item__text",
          class: { "vat-manager-item__text--large": _vm.value.is_ecotax }
        },
        [
          _vm.languageId === 0
            ? _c("el-input", {
                ref: "vatItemInputDefaultLabel",
                staticClass: "wp-10 acenter",
                on: {
                  blur: function() {
                    _vm.$emit("blur")
                  }
                },
                model: {
                  value: _vm.value.label,
                  callback: function($$v) {
                    _vm.$set(_vm.value, "label", $$v)
                  },
                  expression: "value.label"
                }
              })
            : _c("el-input", {
                ref: "vatItemInputLangLabel",
                staticClass: "wp-10",
                model: {
                  value: _vm.translationLabel,
                  callback: function($$v) {
                    _vm.translationLabel = $$v
                  },
                  expression: "translationLabel"
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { ref: "rate", staticClass: "vat-manager-item__rate" },
        [
          _c(
            "el-input",
            {
              ref: "vatItemInputRate",
              attrs: {
                disabled: !_vm.itemCanBeUpdated(_vm.value),
                oninput:
                  "this.value = this.value.replace(/[^\\d.]/g, '').replace(/(\\..*?)\\..*/g, '$1').replace(/^0[^.]/, '0');"
              },
              on: {
                blur: function($event) {
                  _vm.rateFormatPrecision(_vm.value.rate)
                  _vm.onRateBlurEvent()
                }
              },
              model: {
                value: _vm.value.rate,
                callback: function($$v) {
                  _vm.$set(_vm.value, "rate", $$v)
                },
                expression: "value.rate"
              }
            },
            [_vm._v("\n            " + _vm._s(_vm.value.rate) + "\n        ")]
          ),
          _vm._v(" "),
          !_vm.isValueRateEmpty
            ? _c("div", { staticClass: "vat-manager-item__rate--alert-msg" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$l10n.__("Champ manquant")) +
                    "\n        "
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      !_vm.value.is_ecotax
        ? _c(
            "div",
            {
              staticClass: "vat-manager-item__action vat-manager-item__delete"
            },
            [
              _c("CompassIconButton", {
                ref: "vatItemButtonDelete",
                attrs: {
                  disabled: !_vm.itemCanBeDeleted(_vm.value),
                  icon: "bin"
                },
                on: {
                  click: function($event) {
                    return _vm.removeTaxe(_vm.value)
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }